import { createFeature, createReducer, createSelector, on } from '@ngrx/store';

import { MapReportGroupActions } from './map-report-group.actions';
import { initialState, MapReportGroupState } from './map-report-group.state';
import { AsyncRequestStatus, requestStatusInProgress } from '@portal/shared/store/request-status';
import { EditReportGroupsFormData } from 'src/app/pages/administration/report-groups/report-groups.types';
import { FilterFieldMapping } from 'src/app/pages/administration/report-groups/components/report-groups-filter-criteria/report-groups-filter-criteria.types';
import { InOpFilter } from 'src/app/pages/administration/report-groups/components/report-groups-filter-criteria/report-groups-dynamic-filter/report-groups-dynamic-filter.const';

const mapReportGroupReducer = createReducer(
  initialState,
  on(MapReportGroupActions.updateSelectedArea, (state, { area }): MapReportGroupState => ({
    ...state,
    selectedArea: area
  })),
  on(MapReportGroupActions.fetchDevicesForSelectedAreaSuccess, (state, { deviceIds }): MapReportGroupState => ({
    ...state,
    ...(deviceIds.length
      ? {
          reportGroupFormData: {
            ...state.reportGroupFormData,
            groupCriteria: [
              ...(state.reportGroupFormData?.groupCriteria?.filter(
                criteria => criteria.name !== FilterFieldMapping.DeviceUID.value
              ) ?? []),
              {
                name: FilterFieldMapping.DeviceUID.value,
                operator: InOpFilter.value,
                values: deviceIds,
                attributeType: 'Device'
              }
            ]
          } as EditReportGroupsFormData
        }
      : null),
    selectedIds: deviceIds
  })),
  on(MapReportGroupActions.toggleReportGroupCreation, (state, { paused }): MapReportGroupState => ({
    ...state,
    selectedArea: [],
    hasPausedReportGroup: paused
  })),
  on(
    MapReportGroupActions.cancelReportGroupCreation,
    MapReportGroupActions.createReportGroupSuccess,
    (state): MapReportGroupState => ({
      ...initialState,
      initialApplicable: state.initialApplicable,
      reportGroupFormData: {
        ...initialState.reportGroupFormData,
        applicable: state.initialApplicable
      }
    })
  ),
  on(MapReportGroupActions.createReportGroup, (state): MapReportGroupState => ({
    ...state,
    createReportGroupRequest: requestStatusInProgress()
  })),
  on(MapReportGroupActions.updateInitialApplicable, (state, { applicable }): MapReportGroupState => ({
    ...state,
    initialApplicable: applicable,
    reportGroupFormData: {
      ...state.reportGroupFormData,
      applicable
    }
  }))
);

export const mapReportGroupFeature = createFeature({
  name: 'mapReportGroup',
  reducer: mapReportGroupReducer,
  extraSelectors: ({ selectCreateReportGroupRequest }) => ({
    selectIsReportGroupCreating: createSelector(
      selectCreateReportGroupRequest,
      request => request.status === AsyncRequestStatus.InProgress
    )
  })
});

export const {
  selectHasPausedReportGroup,
  selectIsReportGroupCalculating,
  selectIsReportGroupCreating,
  selectReportGroupFormData,
  selectSelectedArea,
  selectSelectedIds
} = mapReportGroupFeature;
